import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.735 6.597c2.08 1.854 2.456 3.772 2.51 4.676q.005.112.005.226c0 3.314-2.798 6.001-6.25 6.001s-6.25-2.687-6.25-6.001q0-.486.077-.95l-.003.062c.145-1.343 1.498-3.277 2.187-4.116a.06.06 0 0 1 .076-.011L7.78 7.536a.18.18 0 0 0 .276-.137c.241-3.724 2.39-4.648 3.126-4.896a.058.058 0 0 1 .077.053c.034 1.358.953 2.683 2.477 4.041M10 16.25a2.917 2.917 0 1 0 0-5.834 2.917 2.917 0 0 0 0 5.834",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }